"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.isValidDate = exports.getValueFromObject = exports.getValue = exports.formatDefault = void 0;
var parse_1 = __importDefault(require("date-fns/parse"));
var parseISO_1 = __importDefault(require("date-fns/parseISO"));
exports.formatDefault = 'dd-MM-yyyy';
exports.getValue = function (value, format) {
    if (format === void 0) { format = exports.formatDefault; }
    if (value === null) {
        return null;
    }
    if (typeof value === 'string' && value !== '') {
        var re = parseISO_1["default"](value);
        if (isNaN(re.getTime())) {
            return parse_1["default"](value, format, new Date());
        }
        return re;
    }
    if (typeof value === 'number') {
        return new Date(value);
    }
    return value;
};
exports.getValueFromObject = function (name, data, format) {
    return exports.getValue(data[name], format);
};
exports.isValidDate = function (d) {
    return d instanceof Date && !isNaN(d.getTime());
};
